import { render, staticRenderFns } from "./JingMu.vue?vue&type=template&id=4701bb78&scoped=true"
import script from "./JingMu.vue?vue&type=script&lang=js"
export * from "./JingMu.vue?vue&type=script&lang=js"
import style0 from "./JingMu.vue?vue&type=style&index=0&id=4701bb78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4701bb78",
  null
  
)

export default component.exports